import { List } from "@mui/material";
import FilterList from "./filter-list";
import React from "react";
import { FacetFields } from "models/facet-fields";

const FacetList = ({
  facetFields,
  OnUpdated,
}: {
  facetFields: FacetFields;
  OnUpdated: (filterType: string, filter: string) => void;
}) => {
  return (
    <List sx={{ p: 0 }} aria-labelledby="nested-list-subheader">
      {facetFields &&
        Object.keys(facetFields).length > 0 &&
        Object.keys(facetFields)
          .filter(
            (facet) =>
              facet && facetFields[facet] && facetFields[facet].length > 0,
          )
          .map((facet, index) =>
            ["FAF-nt"].includes(process.env.REACT_APP_STYLING_THEME ?? "") &&
            ["Domains", "Groups", "boundaries", "points"].includes(
              facet,
            ) ? null : (
              <FilterList
                key={`facet-${facet}`}
                facetType={facet}
                facetFilters={facetFields[facet]}
                OnUpdated={OnUpdated}
                index={index}
              />
            ),
          )}
    </List>
  );
};

export default FacetList;
